import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import useAxios from "middleware/useAxios";
import { Row, Col, notification } from "antd";

import { Button, Form, Input, Select, Space } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

import Axios from "middleware/axiosInstance";
import Loading from "layouts/Loading/Loading";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";

const { TextArea } = Input;
const SettingOfPrefaktorDocument = () => {
  const navigate = useNavigate();
  const [footerItems, setFooterItems] = useState(null);
  const [form] = Form.useForm();

  const getFactorFooterItems = () =>
    Axios.get("/footer").then((res) => {
      setFooterItems({ items: res.data });
      console.log({ items: res.data });
    });

  const handleChangeFooterItems = (e) => {
    Axios.post("/footer", e).then((res) => {
      if (res.status === 201) {
        OpenNotificationWithIcon("ویرایش موفق", "ویرایش با موفقیت انجام شد!");
        navigate("/");
      } else {
        OpenNotificationWithIcon("ویرایش ناموفق", "ویرایش انجام نشد!");
      }
    });
  };
  useEffect(() => {
    getFactorFooterItems();
  }, []);

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session d-print-none">تنظیمات پیش فاکتور</h5>
        {footerItems ? (
          <Form
            // layout="horizental"
            layout="vertical"
            // layout="inline"
            // {...formItemLayout}
            // layout={
            //     "span": 12,
            //     "offset": 12,
            //   },
            initialValues={footerItems}
            form={form}
            // onValuesChange={handleFormValuesChange}
            autoComplete="off"
            scrollToFirstError
            labelCol={{ xs: 24 }}
            onFinish={handleChangeFooterItems}
          >
            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.List
                  name="items"
                  // onValuesChange={(e) => {
                  //     console.log(e);
                  // }}
                >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{ display: "flex", marginBottom: 8 }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "radif"]}
                            label="ردیف"
                          >
                            {/* row number */}
                            {name + 1}
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "description"]}
                            label="توضیحات ردیف"
                            rules={[
                              {
                                required: true,
                                message: "فیلد اجباری است",
                              },
                            ]}
                          >
                            <TextArea
                              rows={4}
                              type="text"
                              placeholder="شماره حساب بانک پاسارگاد ما..."
                              min="1"
                              autoSize={{ minRows: 2, maxRows: 4 }}
                            />
                          </Form.Item>
                          <MinusCircleOutlined
                            onClick={() => {
                              remove(name);
                            }}
                          />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          ایجاد یک ردیف جدید
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
                {/* end form list */}
              </Col>
            </Row>

            <Form.Item
            // {...buttonItemLayout}
            >
              <Button
                htmlType="submit"
                type="primary"
                // onClick={CreateWarehouseEntryDocumentHandler}
              >
                ثبت
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default SettingOfPrefaktorDocument;
